/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useState, useEffect } from "react";
import { Form, InputGroup } from "react-bootstrap";
import { RadioGroup, RadioButton as RadiobuttonLib } from "./RadioButtonLib";
import * as S from "../../styles";

const { toHeaderCase } = require("js-convert-case");

export interface IBooleanButtonProps {
    id: string;
    label?: string;
    labelColor?: string;
    errorText?: string;
    value?: string;
    options: string[];
    required?: boolean;
    placeholder?: string;
    rootColor?: string;
    pointColor?: string;
    onCompChange?(id: string, payload: any): void;
    hasError?: boolean;
}

export const BooleanButton = ({
    id,
    label,
    labelColor,
    hasError,
    errorText,
    value,
    required,
    placeholder,
    options,
    onCompChange,
    rootColor,
    pointColor
}: IBooleanButtonProps) => {
    const [textValue, setTextValue] = useState(value ?? "");
    const onChange = (id: string, e: any) => {
        onCompChange && onCompChange(id, e);
    };

    const _renderLabelIf = () => {
        if (label) {
            return (
                <S.FormLabel color={labelColor}>
                    {label}
                    {required && <sup style={{ color: "red" }}>*</sup>}
                </S.FormLabel>
            );
        }
        return null;
    };

    const _renderErrorTextIf = () => {
        if (hasError && errorText) {
            return (
                <S.FeedbackOtherLabel type="tooltip">
                    {errorText}
                </S.FeedbackOtherLabel>
            );
        }
        return null;
    };

    return (
        <>
            <Form.Group id={id} className="mb-4">
                {_renderLabelIf()}
                <InputGroup>
                    <div style={{ width: "100%" }}>
                        <RadioGroup
                            value={textValue}
                            onChange={onChange.bind(null, id)}
                            horizontal
                        >
                            <RadiobuttonLib
                                value={options[0]?.toLowerCase()}
                                iconSize={20}
                                iconInnerSize={10}
                                rootColor={rootColor}
                                pointColor={pointColor}
                            >
                                {toHeaderCase(options[0] ?? "yes")}
                            </RadiobuttonLib>
                            <RadiobuttonLib
                                value={options[1]?.toLowerCase()}
                                iconSize={20}
                                iconInnerSize={10}
                                rootColor={rootColor}
                                pointColor={pointColor}
                            >
                                {toHeaderCase(options[1] ?? "yes")}
                            </RadiobuttonLib>
                        </RadioGroup>
                    </div>
                    <InputGroup>{_renderErrorTextIf()}</InputGroup>
                </InputGroup>
            </Form.Group>
        </>
    );
};

BooleanButton.defaultProps = {
    required: false,
    rootColor: "grey",
    pointColor: "#000000",
    options: ["Yes", "no"],
    hasError: false
};
